import { render, staticRenderFns } from "./CreateForm copy.vue?vue&type=template&id=50eabf4a&scoped=true"
import script from "./CreateForm copy.vue?vue&type=script&lang=js"
export * from "./CreateForm copy.vue?vue&type=script&lang=js"
import style0 from "./CreateForm copy.vue?vue&type=style&index=0&id=50eabf4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eabf4a",
  null
  
)

export default component.exports